import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { initials } from '@/lib/format'

const PALETTE = [
    'bg-teal-50 text-teal-800 ring-teal-100',
    'bg-sky-50 text-sky-800 ring-sky-100',
    'bg-emerald-50 text-emerald-800 ring-emerald-100',
    'bg-slate-100 text-slate-700 ring-slate-200'
]

const hash = (value: string): number => {
    let total = 0
    for (let index = 0; index < value.length; index += 1) total = (total * 31 + value.charCodeAt(index)) % 9973
    return total
}

interface PatientAvatarProps {
    name: string
    size?: 'sm' | 'md' | 'lg'
    className?: string
}

const SIZES = {
    sm: 'size-8 text-xs',
    md: 'size-10 text-sm',
    lg: 'size-14 text-lg'
}

const PatientAvatar = ({ name, size = 'sm', className }: PatientAvatarProps): ReactNode => {
    return (
        <span
            aria-hidden='true'
            className={cn(
                'inline-flex shrink-0 items-center justify-center rounded-full font-semibold ring-1 ring-inset',
                PALETTE[hash(name) % PALETTE.length],
                SIZES[size],
                className
            )}
        >
            {initials(name)}
        </span>
    )
}

export default PatientAvatar
